import { useEffect, useState } from "react";
import "./VerificationCode.scss";
import logo from "../../../assets/images/MainLogo.png";
import Buttons from "../../../components/Buttons/Buttons";
import { useNavigate } from "react-router-dom";
import { UserForgotPassword, UserVerifyOTP } from "../../../utils/apiCalls/auth";
import Spinner from "../../../components/Spinner/Spinner";
import OtpInput from "react-otp-input";
import { useToast } from "../../../utils/ToastContext";

const VerificationCode = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToast();
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    let intervalId;
    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [timer]);

  const handleVerifyCode = async () => {
    if (isLoading) return;
    const fullOTP = otp;
    const email = sessionStorage.getItem("email");
    setIsLoading(true);
    if (validateFields()) {
      const payload = { otp: fullOTP };
      try {
        const res = await UserVerifyOTP(payload, email);
        const { statusCode, message } = res;
        if (statusCode === 200) {
          setIsLoading(false);
          navigate("/reset-password");
        } else {
          setIsLoading(false);
          showToast(message, "error");
        }
      } catch (error) {
        setIsLoading(false);
        showToast(error?.message, "error");
      }
    } else {
      setIsLoading(false);
    }
  };

  const validateFields = () => {
    if (otp.length !== 6) {
      showToast("Please enter the complete 6-digit code", "error");
      return false;
    }
    return true;
  };

  const handleForgotPassword = async () => {
    if (isLoading) return;
    const email = sessionStorage.getItem("email");
    if (!email) {
      showToast("Email address session not found. Please restart the request.", "error");
      return;
    }
    setIsLoading(true);
    const payload = {
      email: email,
    };
    try {
      const res = await UserForgotPassword(payload);
      const { message, statusCode } = res;
      setIsLoading(false);
      if (statusCode === 200 || statusCode === 204) {
        showToast(message || "Verification code resent successfully", "success");
        setTimer(60);
      } else {
        showToast(message || "Failed to resend code", "error");
      }
    } catch (error) {
      setIsLoading(false);
      showToast(error?.message || "Failed to resend code", "error");
    }
  };

  return (
    <div className="vc">
      {isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <div className="vc_bcg">
        <div className="vc_container">
          <div className="vc_section">
            <div className="vc_section_logo">
              <img src={logo} alt="logo" />
            </div>
            <div className="vc_section_header">
              <h3>Verification Code</h3>
              <p>Enter the 6 digit code that you received on your email</p>
            </div>
            <div className="vc_section_inputs">
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                inputType="tel"
                separator={null}
                renderInput={(props) => <input {...props} />}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleVerifyCode();
                  }
                }}
              />
            </div>
            <div className="vc_section_resend">
              {timer > 0 ? (
                <p>
                  Resend OTP in {timer < 10 ? `00:0${timer}` : `00:${timer} `}
                </p>
              ) : (
                <p>
                  If you didn't Receive a code!{" "}
                  <button type="button" className="link-button" onClick={handleForgotPassword}>
                    Resend
                  </button>
                </p>
              )}
            </div>
            <div className="vc_section_buttons">
              <Buttons
                text={"Verify"}
                variant="primary"
                onClick={handleVerifyCode}
                disabled={isLoading}
              />
            </div>
            <div className="vc_section_back">
              <button type="button" className="back-link" onClick={() => navigate("/")}>
                Back to Sign In
              </button>
            </div>
          </div>
        </div>
        <div className="vc_bcglayout"></div>
      </div>
    </div>
  );
};

export default VerificationCode;
